<!--<template>
  <div class="con monitor" id="uav">
    <video
      id="my-player1"
      class="video-js vjs-default-skin"
      preload="auto"
      data-setup='{ "html5" : { "nativeTextTracks" : false } }'
      controls
    ></video>
  </div>
</template>

<script>
/*  下载的包
       "video.js": "^5.1.9",
       "videojs-flash": "^2.1.0"
       "videojs-swf": "^5.4.2",
    */
import videojs from "video.js";
import "videojs-contrib-hls";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
// import {videoPlayer} from 'vue-video-player'
import "videojs-flash";
// import SWF_URL from "videojs-swf/dist/video-js.swf";
// videojs.options.flash.swf = SWF_URL // 设置flash路径，Video.js会在不支持html5的浏览中使用flash播放视频文件

export default {
  name: "videojs",
  components: {
    // videoPlayer
  },
  mounted() {
    // let uva = document.getElementById("uav")
    // uva.innerHTML = ""
    this.close()
  },
  data() {
    return {
      // options1: {},
      player1: {}
    };
  },
  methods: {
    initPlayer() {
      this.player1 = videojs(
        "my-player1",
        {
          autoplay: true, // 是否自动播放
          muted: false, // 是否静音
          controls: true,
          // isFS:true,
          enterFullWindow:true,
          // requestFullscreen:true,
          fluid: true, // 宽高自适应
          // width: 1920,
          height:"100vh",
          // height:140, 
          // width:540,
          // aspectRatio: "8:3",
          sources: [
            {
              src: "rtmp://117.78.48.109:1935/live/livestream",
              // src: "rtmp://58.200.131.2:1935/livetv/hunantv",
              type: "rtmp/flv"
            }
          ]
        },
        function onPlayerReady() {
          videojs.log("播放器已经准备好了!");
          this.on("play", function () {
            console.log("开始/恢复播放");
          });
          this.on("pause", function () {
            console.log("暂停播放");
          });
          this.on("ended", function () {
            console.log("结束播放");
          });
        },
      );
      setTimeout(() => {
        this.player1.player();
      }, 1000);

    },
    close() {
      var oldPlayer = document.getElementById('my-player1');
      videojs(oldPlayer).dispose();
      let uav = document.getElementById('uav')
      uav.innerHTML = ""
      uav.innerHTML = `
      <video
      id="my-player1"
      class="video-js vjs-default-skin"
      preload="auto"
      data-setup='{ "html5" : { "nativeTextTracks" : false } }'
      controls
    ></video>`
      this.initPlayer()
    }
  },
};
</script>

<style scoped >
.video-js {
  object-fit: fill;
}

#uav {
  width: 100vw;
  /* height: 100vh; */
}
</style>
-->

<template>
  <div class="con monitor" id="uav">
    <video
      id="my-player1"
      class="video-js vjs-default-skin"
      preload="auto"
      data-setup='{ "html5" : { "nativeTextTracks" : false } }'
      controls
    ></video>
  </div>
</template>

<script>
/*  下载的包
       "video.js": "^5.1.9",
       "videojs-flash": "^2.1.0"
       "videojs-swf": "^5.4.2",
    */
import videojs from "video.js";
import "videojs-contrib-hls";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
// import {videoPlayer} from 'vue-video-player'
import "videojs-flash";
// import SWF_URL from "videojs-swf/dist/video-js.swf";
// videojs.options.flash.swf = SWF_URL // 设置flash路径，Video.js会在不支持html5的浏览中使用flash播放视频文件

export default {
  name: "videojs",
  components: {
    // videoPlayer
  },
  mounted() {
    // let uva = document.getElementById("uav")
    // uva.innerHTML = ""
    this.close()
  },
  data() {
    return {
      // options1: {},
      player1: {}
    };
  },
  methods: {
    initPlayer(){
    this.player1 = videojs(
      "my-player1",
      {
        autoplay: true, // 是否自动播放
        muted: false, // 是否静音
        controls: true,
        fluid: false, // 宽高自适应
        width: "1080px",
        // height:1140, 
        // width:540,
        aspectRatio:"1140:540",
        sources: [
          {
            src: "rtmp://117.78.48.109:1935/live/livestream",
            // src: "rtmp://58.200.131.2:1935/livetv/hunantv",
            type: "rtmp/flv"
          }
        ]
      },
      function onPlayerReady() {
        videojs.log("播放器已经准备好了!");
        this.on("play", function() {
          console.log("开始/恢复播放");
        });
        this.on("pause", function() {
          console.log("暂停播放");
        });
        this.on("ended", function() {
          console.log("结束播放");
        });
      },
    );
    setTimeout(() => {
      this.player1.player();
    }, 1000);

    },
    close(){
      var oldPlayer = document.getElementById('my-player1');
      videojs(oldPlayer).dispose();
      let uav = document.getElementById('uav')
      uav.innerHTML = ""
      uav.innerHTML =  `
      <video
      id="my-player1"
      class="video-js vjs-default-skin"
      preload="auto"
      data-setup='{ "html5" : { "nativeTextTracks" : false } }'
      controls
    ></video>` 
    this.initPlayer()
    }
  },
};
</script>

<style scoped >
  video{
    object-fit:fill;
  }

  #uav{
    width: 100vh;
  }
</style>